import { createStore as createVueStore, Store } from "vuex";
import { store as CarStore } from "@/cars/store";
import { store as AccountStore } from "@/accounts/store";
import { store as ImprovementFormStore } from "@/improvementForms/store";

export interface State {
  phoneNumber: String;
  email: String;
  regulations: String;
  privacyPolicy: String;
  menuIsOpen: Boolean;
  initObject: Object | undefined | null;
}

export function createStore(): Store<State> {
  return createVueStore({
    modules: {
      cars: CarStore,
      accounts: AccountStore,
      improvementForm: ImprovementFormStore,
    },
    state(): State {
      return {
        phoneNumber: "+48 505 514 002",
        email: "pomoc@carspot24.pl",
        regulations:
          "https://carspot24.pl/static/pdf/Regulamin_serwisu_internetowego_Carspot24.pdf",
        privacyPolicy:
          "https://carspot24.pl/static/pdf/Polityka_Prywatności_Serwisu_Internetowego_Carspot24.pdf",
        menuIsOpen: false,
        initObject: null,
      };
    },
    getters: {
      getPhoneNumber(state: State) {
        return state.phoneNumber;
      },
      getEmail(state: State) {
        return state.email;
      },
      getRegulations(state: State) {
        return state.regulations;
      },
      getPrivacyPolicy(state: State) {
        return state.privacyPolicy;
      },
      isMenuOpen(state: State) {
        return state.menuIsOpen;
      },
      getInitObject(state: State) {
        return { object: state.initObject };
      },
    },
    mutations: {
      openMenu(state: State) {
        state.menuIsOpen = true;
      },
      closeMenu(state: State) {
        state.menuIsOpen = false;
      },
      setInitObject(state: State, object: string | undefined) {
        state.initObject = object;
      },
      resetInitObject(state: State) {
        state.initObject = null;
      },
    },
  });
}
